import React, { Fragment } from 'react'
import { Radar } from '@nivo/radar'

// @ts-ignore
import { trimString } from 'helpers/common'
import { NA } from '../../../constants'
// @ts-ignore
import { COLORS, DIRECT, PEERS, SELF, SUPERVISORS, COLORS_FOR_RADAR_CHART_T2 } from '../../../Reports'
import TitleForRadarAndBar from '../../TitleForRadarAndBar'
import { IRadarChartT2ForPrintingProps } from './interface'

const theme = {
  axis: {
    ticks: {
      text: {
        fontSize: 12,
      },
    },
  },
  dots: {
    text: {
      fontSize: 14,
    },
  },
}

const renderLabelComponent =
  (data: any) =>
  ({ id, anchor }: any): any => {
    const offsetX = id.length + 1
    const isMiddle = anchor === 'middle'
    const isEnd = anchor === 'end'
    const comp = data.find(({ competency }: { competency: string }) => competency === id)
    const styles = {
      fontSize: '10px',
      fontFamily: 'Avenir, sans-serif',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.3,
      letterSpacing: 'normal',
      fill: '#626262',
    }
    return (
      <g transform={`translate(${isEnd ? -offsetX * 6 : isMiddle ? -offsetX * 3 : 5}, ${isMiddle ? -20 : -10})`}>
        <text style={styles}>{isMiddle ? id.toUpperCase() : trimString(id.toUpperCase(), 18)}</text>
        <text transform={`translate(0, 20)`} style={styles}>
          {`T1: ${comp.t1 !== null ? comp.t1 : NA}`}
        </text>
        <text transform={`translate(40, 20)`} style={styles}>
          {`T2: ${comp.t2 !== null ? comp.t2 : NA}`}
        </text>
      </g>
    )
  }

const RadarChartT2ForPrinting: React.FC<IRadarChartT2ForPrintingProps> = ({ data, reviewer, subtitle }) => {
  return (
    <Fragment>
      <TitleForRadarAndBar
        // @ts-ignore
        reviewerType={reviewer}
        title="Competency Ratings 2"
        subtitle={subtitle}
      />
      <Radar
        // @ts-ignore
        data={data}
        keys={['t1', 't2']}
        indexBy="competency"
        width={500}
        height={450}
        colors={(node: any) => {
          return COLORS_FOR_RADAR_CHART_T2[node.key][reviewer]
        }}
        maxValue={4}
        fillOpacity={0}
        margin={{ top: 70, right: 0, bottom: 80, left: 0 }}
        blendMode="normal"
        gridLevels={4}
        gridShape="circular"
        curve="linearClosed"
        borderWidth={3}
        borderColor={{ from: 'color' }}
        gridLabelOffset={10}
        animate
        motionStiffness={90}
        motionDamping={15}
        // @ts-ignore
        theme={theme}
        dotSize={0}
        // @ts-ignore
        gridLabel={renderLabelComponent(data)}
      />
    </Fragment>
  )
}

export default RadarChartT2ForPrinting
